import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Container, Header, Segment, Grid, Card, Message, Button, Icon } from 'semantic-ui-react';
import '../Playbook.css';

class ExampleSalesDeck extends Component {
    render() {
        return (
            <Container fluid className="playbook-container">
                <h1 className="ui icon center aligned header playbook-branded-header" style={{fontFamily: 'Montserrat', textTransform: 'uppercase', color: 'rgb(35, 37, 58)', fontWeight: 600, fontSize: '38px', marginBottom: '-9px'}}>
                    <i aria-hidden="true" className="icon">
                        <img src="/static/media/logo-icon.7bb8994723bbdcd674f1.png" alt="logo-icon" style={{height: '68px', marginBottom: '-15px'}} />
                    </i>
                    Building The Message
                </h1>
                <div className="ui divider"></div>

                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment className="playbook-content">
                                <Header as="h2" className="section-header">Examples Sales Deck</Header>
                                
                                <Message info>
                                    <Message.Header>Template Reference</Message.Header>
                                    <p>
                                        This is the Multiply Sales deck. You can use it as a template, but the point is that you are trying to create 6-8 slides that coincide with the "Who Are We" messaging.
                                    </p>
                                </Message>

                                <Card fluid className="highlight-card" color="blue">
                                    <Card.Content>
                                        <Card.Header>
                                            <Icon name="download" />
                                            Multiply Sales Deck Template
                                        </Card.Header>
                                        <Card.Description>
                                            <p>
                                                Access our comprehensive sales deck that exemplifies the strategic messaging framework 
                                                detailed throughout this section. This proven presentation template has been refined 
                                                through successful implementations across diverse industries and organizational scales, 
                                                providing you with a practical foundation for developing your own compelling sales narrative.
                                            </p>
                                            
                                            <Button 
                                                primary
                                                icon="download" 
                                                labelPosition="left"
                                                size="large"
                                                content="Download Sales Deck Template"
                                                href="/downloads/multiply-sales-deck-template.pptx"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            />
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Grid stackable>
                                    <Grid.Row>
                                        <Grid.Column width={8}>
                                            <Card fluid>
                                                <Card.Content>
                                                    <Card.Header>
                                                        <Icon name="lightbulb" />
                                                        Key Elements
                                                    </Card.Header>
                                                    <Card.Description>
                                                        <p><strong>Corporate Credibility Slides (2-4):</strong></p>
                                                        <ul>
                                                            <li>Mission and company background</li>
                                                            <li>Sales management framework</li>
                                                            <li>Representative client base</li>
                                                        </ul>
                                                        
                                                        <p><strong>Differentiation Slides (5-7):</strong></p>
                                                        <ul>
                                                            <li>Traditional sales management gaps</li>
                                                            <li>The 80/20 rule problem</li>
                                                            <li>Our solution pattern</li>
                                                        </ul>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                        
                                        <Grid.Column width={8}>
                                            <Card fluid>
                                                <Card.Content>
                                                    <Card.Header>
                                                        <Icon name="target" />
                                                        Structure Focus
                                                    </Card.Header>
                                                    <Card.Description>
                                                        <p><strong>Offerings Slide (8):</strong></p>
                                                        <ul>
                                                            <li>Clear product/service overview</li>
                                                            <li>Software demonstration approach</li>
                                                            <li>Engagement model options</li>
                                                        </ul>
                                                        
                                                        <p><strong>Engagement Slides (9-10):</strong></p>
                                                        <ul>
                                                            <li>Pricing transparency</li>
                                                            <li>Next steps framework</li>
                                                            <li>Proposal qualification</li>
                                                        </ul>
                                                    </Card.Description>
                                                </Card.Content>
                                            </Card>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>

                                <Message warning>
                                    <Message.Header>Customization Guidelines</Message.Header>
                                    <p>
                                        While our deck serves as an excellent template, remember to customize it for your specific industry, company size, and target market. The structure remains consistent, but the content should reflect your unique value proposition and market position.
                                    </p>
                                </Message>

                                <Card.Group itemsPerRow={1}>
                                    <Card>
                                        <Card.Content>
                                            <Card.Header>
                                                <Icon name="clock" />
                                                Timing Considerations
                                            </Card.Header>
                                            <Card.Description>
                                                <p>
                                                    The complete presentation should take approximately 15-20 minutes to deliver, allowing for:
                                                </p>
                                                <ul>
                                                    <li><strong>10 minutes:</strong> Company background and credibility building</li>
                                                    <li><strong>5 minutes:</strong> Offerings overview and demonstration</li>
                                                    <li><strong>5+ minutes:</strong> Engagement discussion and Q&A</li>
                                                </ul>
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>

                                    <Card>
                                        <Card.Content>
                                            <Card.Header>
                                                <Icon name="users" />
                                                Audience Adaptation
                                            </Card.Header>
                                            <Card.Description>
                                                <p>
                                                    The deck structure works across different presentation formats:
                                                </p>
                                                <ul>
                                                    <li>Formal boardroom presentations</li>
                                                    <li>Video conference meetings</li>
                                                    <li>Casual coffee meetings (abbreviated version)</li>
                                                    <li>Elevator pitch scenarios (key slides only)</li>
                                                </ul>
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>

                                    <Card>
                                        <Card.Content>
                                            <Card.Header>
                                                <Icon name="edit" />
                                                Content Maintenance
                                            </Card.Header>
                                            <Card.Description>
                                                <p>
                                                    Keep your deck current by updating:
                                                </p>
                                                <ul>
                                                    <li>Client testimonials and case studies</li>
                                                    <li>Revenue and growth metrics</li>
                                                    <li>New product features or services</li>
                                                    <li>Market expansion and team growth</li>
                                                    <li>Industry recognition and awards</li>
                                                </ul>
                                            </Card.Description>
                                        </Card.Content>
                                    </Card>
                                </Card.Group>

                                <Message info>
                                    <Message.Header>Implementation Notes</Message.Header>
                                    <p>
                                        Remember that this deck is designed to earn the right to ask questions and engage in problem-solving conversations. It's not meant to close deals on its own, but rather to establish credibility, differentiate your approach, and qualify prospects effectively.
                                    </p>
                                    <p>
                                        The goal is to transition from presenting about your company to having meaningful conversations about the prospect's business within the framework you've established.
                                    </p>
                                </Message>

                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default observer(ExampleSalesDeck);